
module dg.objects {

    export class ImageViewerController implements ng.IController {

        public constructor(
            private $http: ng.IHttpService,
            private $base64: any
        ) {
            //this.getPng().then((data) => {
            //  //  this.image = data.data;

            //    let base64Data = $base64.encode(data);
            //    let fileURL = 'data:image/png;base64,' + base64Data;
            //    //var file = new Blob([data.data], { type: 'image/png' });
            //    //var fileURL = URL.createObjectURL(file);
                
            //    this.image = fileURL;
            //   // this.image = data.data;
            //});;

        }

        $onInit() {

        }

        public image: string;

        public getPng(): ng.IPromise<any> {

            //let resultLink = angular.isDefined(link) ? link : query.dgMeta.links[query.dgMeta.id + '_invoke'];
            //let resultRequest = this.createOneReqeustFromLink(resultLink.href);
            //let queryParams = this.getQueryParams(query);

            return this.$http({
                method: 'GET',
                url: 'https://localhost:8090/api/v1/1000/flight-leg/358927539298631680/parameters-chart/result?StartSecond=100&EndSecond=1000',
                headers: {
                   responseType: "blob",
                  //  'responseType': "image/png",
                    'Accept': 'image/png'
                }
            })
                .then(function (result) {
                    //var file = new Blob([result], { type: 'image/png' });
                    //var fileURL = URL.createObjectURL(file);
                    //this.image = fileURL;
            }, function () {

            });
        }
    }

    angular.module('dg.objects').component('imageViewer', {
        bindings: {
           image: '<'
        },
        controller: ImageViewerController,
        templateUrl: '/digmo/src/objects/image-viewer.html'
    });
}